// extracted by mini-css-extract-plugin
module.exports = {"accordionBody":"styles_accordionBody__K1pcl"};